import styled, { css } from 'styled-components';
import { rtl } from '../../utils/language';

export const Wrapper = styled.div`
  background-color: var(--white);
  margin-top: 40px;
  position: relative;
  width: 100%;
  border-radius: 10px;

  table {
    tbody {
      tr {
        td.view-button-cell {
          width: 220px;
          @media screen and (min-width: 1025px) {
            button {
              visibility: hidden;
              display: flex;
            }
          }
        }
      }

      @media screen and (min-width: 1025px) {
        tr:hover {
          td.view-button-cell {
            button {
              visibility: visible;
            }
          }
        }
      }
    }
  }
`;

export const HeaderCheckbox = styled.span`
  margin-left: 50px;

  ${rtl`
      margin-left: 0;
      margin-right: 50px;
  `};
`;

export const SeparatorWrapper = styled.div`
  position: absolute;
  left: 107px;
`;

export const TextAreaWrapper = styled.div`
  width: 400px;
`;

export const SeparatorTitle = styled.div`
  position: relative;
  top: -11px;
  left: -53px;
  width: 904px;
  text-align: left;
  padding: 5px 0px;
  font-weight: bold;
`;

export const ButtonWrapper = styled.div`
  button {
    font-family: Signika;
    line-height: 1.5;
    width: 91px;
  }

  svg {
    margin: 0 5px;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  margin: 20px 0px;
  align-items: center;

  button {
    width: 180px;
  }
`;

export const SelectWrapper = styled.div`
  margin: 0px 20px;
  width: 200px;

  .select__text {
    ${rtl`
      text-align: right;
    `};
  }
`;

export const GiveFeedbackWrapper = styled.div`
  display: inline-block;
  width: 30px;
  height: 30px;
  border: 1px solid var(--silver);
  font-size: var(--font-size-large);
  background: white;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  font-weight: bold;
  text-align: center;

  :hover {
    border-color: var(--river-bed);
  }
`;

export const FeedbackIconWrapper = styled.div`
  cursor: ${p => (p.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SortWrapper = styled.div`
  margin: 0px 5px;
  display: inline-block;
  cursor: pointer;

  .up {
    transform: rotate(180deg);
    margin-right: -5px;
  }
`;

export const StudentDetailsWrapper = styled.div`
  display: inline-block;
  text-align: left;
  margin-left: 50px;

  ${rtl`
      margin-left: 0;
      margin-right: 50px;
  `};
`;

export const GradeScoreWrapper = styled.div`
  white-space: nowrap;
  cursor: pointer;
  font-size: var(--font-size-medium);
  display: flex;
  align-self: flex-start;

  ${({ isToBeReturned }) =>
    isToBeReturned
      ? `
      padding: 0 var(--quarter-spacing-unit);
      border-style: dashed;
      border-width: thin;
      border-color: var(--silver);
  `
      : ''};

  ${({ isBelowTreshold }) =>
    isBelowTreshold
      ? `
    background-color: var(--lightRed);
    border-color: white;
    color: white;
    border-radius: var(--input-border-radius);
    display: flex;
    align-items: center;
    padding: 0 var(--quarter-spacing-unit);
    
    & > div {
    line-height: 21px;
    transform: translateY(-1px);
  }
  `
      : ''};
  ${({ isExceedMaxScore }) =>
    isExceedMaxScore
      ? `
      border-style: double;
      border-width: thin;
      border-color: var(--lightRed) !important;
    `
      : ''};
`;

export const NewGradeScoreWrapper = styled.div`
  white-space: nowrap;
  width: fit-content;
  cursor: pointer;
  font-size: var(--font-size-medium);
  display: flex;
  align-self: flex-start;
  gap: 10px;
  height: 22px;
  align-items: center;
`;

export const PercentageBubble = styled.div`
  width: 64px;
  min-width: 64px;
  min-height: 28px;
  padding: 4px 16px;
  border-radius: 100px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-family-signika);
  font-weight: 400;
  word-wrap: break-word;
  ${({ isBelowTreshold }) =>
    isBelowTreshold
      ? `
    background-color: #FFD3D3;
    color:#662C2C;
  }
  `
      : `
      background-color: #D4EBC6;
        color:#2D4C1A;
        `};
  ${({ isExceedMaxScore }) =>
    isExceedMaxScore
      ? `
        background-color: #D4EBC6;
        color:#2D4C1A;
    `
      : ''};
`;

export const GradeBoxWrapper = styled.div`
  display: inline-flex;
  min-width: 70px;
  width: 70px;
  min-height: 28px;
  border: solid 1px var(--assignment-light-gray);
  background-color: #ffffff;
  align-items: center;
  justify-content: center;
  direction: ltr;
  font-family: var(--font-family-signika) !important;
  border-radius: 4px;
  align-self: flex-start;

  :focus-within {
    border-color: var(--assignment-light-gray);
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input {
    font-family: var(--font-family-signika);
    font-weight: 300;
    color: var(--river-bed);
    max-width: 20px;
    border: none;
    background-color: transparent;
    padding: 0;
    text-align: center;
    line-height: 18px;
    font-size: 16px;
  }

  .separator {
    width: 8px;
    color: var(--river-bed);
    height: 18px !important;
    display: flex;
    font-weight: 300;
    font-size: 16px;
    align-items: center;
    justify-content: center;
  }

  .max-score {
    color: var(--river-bed);
    font-size: 16px;
    font-weight: 300;
  }

  ${({ isExceedMaxScore }) =>
    isExceedMaxScore
      ? `
      border-style: double;
      border-width: thin;
      border-color: var(--lightRed) !important;
    `
      : ''};
`;
export const ReturnedScore = styled.div`
  color: var(--river-bed);
  font-size: 14px;
  font-family: var(--font-family-signika);
  font-weight: 300;
  line-height: 16px;
  word-wrap: break-word;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const stickyTableElementCss = css`
  position: sticky;
  z-index: 1;
  top: 0;
`;

const checkBoxColumn = css`
  z-index: 10;
  padding: 10px 53px 10px 22px !important;
  text-align: left !important;
  left: 0;

  ${rtl`
      text-align: right !important;
      padding-left: 53px !important;
      padding-right: 22px !important;
  `};

  ::after {
    background-color: #d8d8d8;
    content: '';
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    width: 1px;

    ${rtl`
      right: unset;
      left: 0;
    `};
  }
`;

const StickyTh = styled.th`
  ${stickyTableElementCss};
  background-color: white;
`;

const StickyLeftTh = styled(StickyTh)`
  ${checkBoxColumn};
  background-color: white;
`;
const StickyLeftTd = styled.td`
  ${stickyTableElementCss};
  ${checkBoxColumn};

  z-index: 9;
`;

const Separator = styled.div`
  width: 50px;
  height: 1px;
  display: inline-block;
`;

const submittedDateWrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  > svg {
    margin: 0 5px;
  }
`;

const DateText = styled.span`
  display: inline-block;
  direction: ltr;
`;

const Styles = {
  ButtonWrapper,
  FilterWrapper,
  SelectWrapper,
  SeparatorTitle,
  SeparatorWrapper,
  StudentDetailsWrapper,
  TextAreaWrapper,
  Wrapper,
  Separator,
  StickyTh,
  StickyLeftTh,
  StickyLeftTd,
  submittedDateWrapper,
  HeaderCheckbox,
  DateText,
};

export default Styles;
